import Vue from 'vue'

export const formatDay = (value: number) => {
  if (value || value === 0) {    
    switch(value){
      case 0: return "Dimanche"
      case 1: return "Lundi"
      case 2: return "Mardi"
      case 3: return "Mercredi"
      case 4: return "Jeudi"
      case 5: return "Vendredi"
      case 6: return "Samedi"      
    }
  }
  return ''
}

Vue.filter('formatDay',formatDay)